import {
    withInterstitial,
} from 'wanderu-component-page-loader';
import {
    ScrollToTopOnMount,
} from 'wanderu-hocs';

const UniversalHomePageContainer = withInterstitial(import('./pages/HomePage'));

const routes = [{
    path: '/',
    key: 'homepage',
    component: ScrollToTopOnMount(UniversalHomePageContainer),
    exact: true,
}];

export { routes };
export default {
    routes,
};
